<template>

  <nav class="breadcrumb-alt" aria-label="breadcrumb">
    <button class="back-btn" @click="$router.go(-1)" aria-label="Volver" title="Volver">
      <font-awesome-icon icon="angle-left" class="back-btn__icon"></font-awesome-icon>
    </button>
    <template v-for="(link, index) in links">

      <router-link class="crumb" v-bind:key="'link-' + index" v-if="link.path" :to="link.path" :title="link.name">
        {{ link.name }}
      </router-link>
      <span class="crumb crumb-current" v-bind:key="'cur-' + index" v-else :title="link.name" aria-current="page">{{ link.name }}</span>
      <span class="separator" v-bind:key="'sep-' + index" v-if="link.path" aria-hidden="true">›</span>

    </template>
  </nav>

</template>

<style lang="scss" scoped>
.breadcrumb-alt {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.1rem;

  padding: 0.25rem 0 0.5rem;
  margin-bottom: 0.35rem;

  font-size: 0.82rem;
  line-height: 1;

  /* Botón, enlaces y actual comparten alto y centrado: nada "se mueve" */
  .back-btn,
  .crumb,
  .separator {
    display: inline-flex;
    align-items: center;
    height: 1.6rem;
  }

  .crumb {
    padding: 0 0.4rem;
    border-radius: 5px;
    text-decoration: none;

    /* Un link.name largo (p. ej. un nombre de documento/campaña sin
       espacios usado como miga de pan) no debe poder ensanchar la barra —
       mismo tope que .crumb-current, aplicado acá también porque antes
       solo protegía la última miga (sin link). */
    max-width: 24ch;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  a.crumb {
    color: var(--color-steel);
    font-weight: 500;
    transition: background-color 0.15s ease, color 0.15s ease;

    &:hover {
      color: var(--color-navy);
      background-color: var(--color-mist);
      text-decoration: none;
    }
  }

  .crumb-current {
    color: var(--color-graphite);
    font-weight: 600;
  }

  .back-btn {
    justify-content: center;
    width: 1.6rem;
    padding: 0;
    margin-right: 0.35rem;

    background: var(--color-white);
    border: 1px solid var(--color-line);
    border-radius: 6px;
    color: var(--color-steel);

    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;

    &:hover {
      color: var(--color-navy);
      background-color: var(--color-mist);
      border-color: var(--color-steel);
    }

    &__icon {
      font-size: 1rem;
      line-height: 1;
    }
  }

  .separator {
    justify-content: center;
    color: var(--color-ghost);
    font-size: 0.95rem;
    padding: 0 0.05rem;
    user-select: none;
  }
}
</style>

<script>
export default {
  props: ['links'],
}
</script>
